import CloseIcon from '@mui/icons-material/Close';
import GavelIcon from '@mui/icons-material/Gavel';
import { Alert, Backdrop, Box, Fade, IconButton, Modal, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

const ClientsModal = ({ clients = [], handleClose, open }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h2" sx={{ mb: 2 }}>
            {t('portal.clients')}
          </Typography>
          {clients.length === 0 ? (
            <Alert severity="info">
              {t('portal.noClients')}
            </Alert>
          ) : (
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
              {clients.map((client) => (
                <Stack key={client._id} direction="row" spacing={2}>
                  <Box sx={{ fontWeight: 'bold', width: '3em', textAlign: 'right' }}>
                    {client.number || <GavelIcon />}
                  </Box>
                  <Box>{client.name}</Box>
                </Stack>
              ))}
            </Box>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

ClientsModal.propTypes = {
  clients: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    number: PropTypes.number,
  })),
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ClientsModal;
